
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"57.625","height":"43.219","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"#717171","d":"M52.823 26.978v8.471l-4.8-2.4v-3.67zm4.8-7.77l-14.406 7.2v9.6l14.406 7.2zm-24.01 4.8v13.208a1.2 1.2 0 01-1.2 1.2H10.8a1.2 1.2 0 01-1.2-1.2V24.01a14.288 14.288 0 01-4.8-.84v15.247a4.8 4.8 0 004.8 4.8h24.01a4.8 4.8 0 004.8-4.8V23.17a14.288 14.288 0 01-4.795.84zm0-19.208a4.8 4.8 0 11-4.8 4.8 4.807 4.807 0 014.802-4.8zM9.6 4.8a4.8 4.8 0 11-4.8 4.8 4.807 4.807 0 014.8-4.8zM33.615 0a9.6 9.6 0 109.6 9.6 9.6 9.6 0 00-9.6-9.6zM9.6 0a9.6 9.6 0 109.6 9.6A9.6 9.6 0 009.6 0z"}})])
          )
        }
      }
    